import * as React from 'react';
import {WidgetProps} from 'react-jsonschema-form';
import DatePicker from 'material-ui-pickers/DatePicker';
import {format, parse} from 'date-fns';

/**
 * This is the default version, as the main version, we list all the items,
 * we don't care about material-ui
 */

const doFormat = (date: Date) => format(date, 'YYYY-MM-DD');

export default (props: WidgetProps) => {
    // const {onChange} = props;
    const options = props.options as any;
    const onChange = (data: Date) => {

        console.log(data);
        if (!data) {
            props.onChange(options.emptyValue || null);
        }

        return props.onChange(doFormat(data));
    };

    const val = props.value ? parse(props.value, 'YYYY-MM-DD', new Date()) : null;
    console.log(val);

    return (
        <DatePicker
            format="[  ]DD/MM/YYYY"
            style={{
                width: '95%',
                marginLeft: '2px'
            }}
            mask={(value: any) => (value ? [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/] : [])}
            value={val}

            disabled={props.disabled || props.readonly}
            autoFocus={props.autofocus}
            onChange={onChange}/>);
};



// WEBPACK FOOTER //
// ./src/components/schemaform/date-widget.tsx